<template>
    <div style="color:white">
        <MenuTopTemplate :titulo="'ENDEREÇO'" :icone="require('../assets/icons/maps-preto.png')" :onPressedClose="voltar"/>

        <div v-if="loading">
            <p style="color: white;">loading</p>
        </div>

        <TelefoneComDDD :mostrar="true" @callback="digitouTelefone"/>

        <h3 style="margin:0px">Dados do endereço</h3>

        <div v-if="clienteNovo" class="card">
            <p style="font-weight: bold;">Parece que você ainda não tem cadastro conosco!</p>
            <p style="font-size: 0.8rem; margin-top: 10px;">Por favor, entre com seus dados abaixo para que possamos realizar sua entrega!</p>
            <p>{{clienteNovoTelefone }}</p>
        </div>

        <div class="anim-entrada" style="margin-bottom: 100px; max-width: 90%; margin-inline: auto;">
            <DadosEndereco
                :usarEnderecoAntigo="this.$route.query.novo !== 'true'"
                :exigirNome="clienteNovo"
                :telefoneCliente="clienteNovoTelefone"
                @onFinished="voltar"
            />
        </div>
    </div>
</template>

<script>
import MenuTopTemplate from '@/components/Base/MenuTopTemplate.vue';
import DadosEndereco from '@/components/Delivery/DadosEndereco.vue';
import TelefoneComDDD from '@/components/Delivery/TelefoneComDDD.vue';

export default {
    name: "DeliveryEnderecoView",
    components: { MenuTopTemplate,  DadosEndereco, TelefoneComDDD },
    data() {
        return {
            clienteNovo: false,
            clienteNovoTelefone: this.$route.query.telefone ?? null,
            retirarNoLocal:this.$store.state.deliveryRetirarNoLocal,
        }
    },
    computed: {
        loading() {return this.$store.state.loading}
    },
    mounted() {
        this.clienteNovo = this.$route.query.novo == "true";
        this.clienteNovoTelefone = this.$route.query.telefone
    },
    methods: {
        voltar() {
            this.$router.go(-2);
        },

        async digitouTelefone(dados) {
            let telefone = dados.telefone

            try {
                await this.$store.dispatch("enviarTelefone", telefone)
                this.clienteNovo = false;
                this.clienteNovoTelefone = telefone
            } catch (error) {
                if (error == 501) {
                    this.clienteNovo = true
                    this.clienteNovoTelefone = telefone
                }
                if (error == 2424) {
                    this.clienteNovo = false
                    this.clienteNovoTelefone = telefone
                }
            }
        }
    }
}
</script>

<style>

</style>
